import { createSlice } from '@reduxjs/toolkit';
import { decode } from 'base-64';

import { clearState, saveToken } from './actions';

export interface AuthState {
    id: string;
    jti: string | null;
    token: string;
    authorized: boolean;
}

const initialState: AuthState = {
    id: '',
    jti: null,
    token: '',
    authorized: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(saveToken.fulfilled, (state, { payload }) => {
            const { token, account } = payload;

            state.authorized = true;

            if (account) {
                state.id = account.id;
            }

            state.token = token;
            state.jti = (() => {
                const parts = token.split('.', 3);
                const tokenStr = decode(parts[1]);

                return JSON.parse(tokenStr).jti;
            })();
        });
        builder.addCase(clearState.fulfilled, () => initialState);
    },
});

export default authSlice.reducer;

export const authReducer = authSlice.actions;
